import { formatDate, parseDate } from "../../utils/parsers";

import React from "react";
import Table from "react-bootstrap/Table";

export default function CaseTable({ pt_name, contacts, survey_mode }) {
  // Determine if contacts should be greyed out based on survey_mode
  const shouldGreyOut = survey_mode === 1;

  // Flatten the contacts object into a single array and remove duplicates
  const allContacts = Object.values(contacts).flat();
  // const uniqueContacts = Array.from(
  //   new Map(
  //     allContacts.map((contact) => [
  //       `${contact.firstname} ${contact.surname} ${contact.adm_start} ${contact.adm_end} ${contact.ward_name} ${contact.ward_start} ${contact.ward_end} ${contact.collectdt}`,
  //       contact,
  //     ])
  //   ).values()
  // );

  const contactMap = allContacts.reduce((acc, contact) => {
    const key = `${contact.firstname} ${contact.surname} ${contact.adm_start} ${contact.adm_end}`;
    if (!acc.has(key)) {
      acc.set(key, {...contact, collectdt: [contact.collectdt]});
    } else {
      const existing = acc.get(key);
      existing.collectdt.push(contact.collectdt);
      acc.set(key, existing);
    }
    return acc;
  }, new Map());
  
  var uniqueContacts = Array.from(contactMap.values()).map(contact => ({
    ...contact,
    collectdt: contact.collectdt.map(date => formatDate(parseDate(date))).join(', <br />')
  }));

  // Remove the current patient from the list
  uniqueContacts = uniqueContacts.filter(contact => `${contact.firstname} ${contact.surname}` !== pt_name);

  return (
    <Table>
      <thead>
        <tr>
          <th rowSpan="2">Name</th>
          <th rowSpan="2">Positive Test Date</th>
          <th colSpan="2">Hospital Admission</th>
          <th colSpan="3">Ward Admission</th>
        </tr>
        <tr>
          <th>Admitted</th>
          <th>Discharged</th>
          <th>Ward</th>
          <th>Admitted</th>
          <th>Discharged</th>
        </tr>
      </thead>
      <tbody>
        {uniqueContacts.map((contact, index) => (
          <tr key={index}>
            <td
              style={{
                // Apply grey color if shouldGreyOut is true
                color: shouldGreyOut ? "grey" : "inherit",
              }}
            >
              {`${contact.firstname} ${contact.surname}`}
            </td>
            <td dangerouslySetInnerHTML={{__html: contact.collectdt}}></td>
            <td>{contact.adm_start ? formatDate(parseDate(contact.adm_start)) : '-'}</td>
            <td>{contact.adm_end ? formatDate(parseDate(contact.adm_end)) : '-'}</td>
            <td>{contact.ward_name}</td>
            <td>{contact.ward_start ? formatDate(parseDate(contact.ward_start)) : '-'}</td>
            <td>{contact.ward_end ? formatDate(parseDate(contact.ward_end)) : '-'}</td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
}   
